import API_BASE_URL from "../../../../../Constants";

export const createManagementCompany = async (formData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/managementcompanies/createManagementCompany`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to create management company");
  }

  return response.json();
};
